export const STAGES = {
  rating: 'rating',
  feedback: 'feedback',
  thanks: 'thanks',
};
